import { defineStore } from 'pinia'
import { fetchItems, createItem } from '@/api/userNotes'
import useCrudStore from '@/hooks/useCrudStore'

export const useUserNotesStore = defineStore('userNotes', () => {
  const { items, currentItems, FetchItems, SaveItem } = useCrudStore({
    fetchItems,
    createItem,
    updateItem: createItem
  })

  return {
    items,
    currentItems,

    FetchItems,
    SaveItem
  }
})
